import { render, staticRenderFns } from "./readAgreement.vue?vue&type=template&id=49dfa092&scoped=true&"
import script from "./readAgreement.vue?vue&type=script&lang=js&"
export * from "./readAgreement.vue?vue&type=script&lang=js&"
import style0 from "./readAgreement.vue?vue&type=style&index=0&id=49dfa092&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dfa092",
  null
  
)

export default component.exports